// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1KeQn","buttons":"PendingPaymentAlert_buttons__3_WVT"};